export default "__VITE_ASSET__ckxlcPi5__"